
import React from 'react';
import { svgAuthPicUrl, svgLogoUrl } from 'src/utilities/logo';
import HeaderAuthButton from '../Buttons/HeaderAuthButton';
import IFrameModal from './IFrameModal';
import { AuthFooter, LogoImage } from './Layout.styles';
import { useContentLoader } from './useContentLoader';
import { equals } from 'ramda';
import { TERM_OF_USE, PRIVACY_POLICY } from 'src/constants';
import { Theme } from '@mui/material/styles/createTheme';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Footer from './Footer';
import SiteSettings from 'src/siteSetting';
import Modal from 'src/components/Modal/TermsModal';
import parse from 'html-react-parser';
import FDICBanner from 'src/components/Layouts/FDICBanner';


interface IProps {
  children: any
  showHeader?: boolean;
  showLoanIntroText?: boolean;
}

const BackgroundContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primaryColor,
}));
const Header = styled('header')(({ theme }) => ({
  width: '100%',
  zIndex: 1000,
  top: 0,
  backgroundColor: theme.palette.mainLight,
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  height: '70px',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: '20px!important',
  paddingRight: '32px!important',
  borderBottom: `1px solid ${theme.palette.borderColor}`,
  [theme.breakpoints.down('sm')]: {
    height: 60,
  },
}))



const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    imageText: {
      position: 'absolute',
      top: 100,
      left: 100,
      zIndex: 1,
      fontWeight: 600,
      fontSize: 35,
      color: theme.palette.mainLight,
      maxWidth: 400,
      fontFamily: 'Martel, serif'
    },
    logo: {
      maxHeight: '60%',
      maxWidth: '95%',
    }
  })
);


const AuthRootLayout = (props: IProps) => {
  const { showLoanIntroText, children, showHeader } = props;
  const classes = useStyles();
  const signupWithTitleEnabled = SiteSettings.generalSignupWithTitleEnabled();

  const { breakpoints } = useTheme();
  const matchesLg = useMediaQuery(breakpoints.down('lg'));

  const {
    open,
    openIframe,
    title,
    content,
    externalURL,
    handleOpen,
    handleClose,
    handleIframeClose,
  } = useContentLoader();
  const renderHBSModal = () => {
    return <Modal
      title={title}
      handleClose={handleClose}
      isOpen={open}
    >
      <Box
        sx={{
          mt: 2,
        }}

      >
        {parse(content)}
      </Box>
    </Modal>
  }

  return (
    <>
      {showHeader ? (
        <Box>
          <Box height="100%">
            <Grid container>
              <Grid
                item
                md={6}
                sm={12}
                sx={{
                  background:
                    'linear-gradient(180deg, rgba(251, 250, 255, 0.5) 0%, rgba(255, 255, 255, 0) 71.99%)',
                }}
                position="relative"
              >
                {renderHBSModal()}
                <IFrameModal title={title} src={externalURL} isOpen={openIframe} handleClose={handleIframeClose} />
                <Box>
                  <FDICBanner/>
                  <Header>
                    <HeaderContainer>
                      <LogoImage src={svgLogoUrl()} alt="" />
                      <HeaderAuthButton />
                    </HeaderContainer>
                  </Header>
                </Box>
                {children({
                  handleOpen,
                })}
              </Grid>
              <BackgroundContainer
                md={6}
                sx={{
                  [breakpoints.down('md')]: {
                    display: 'none',
                  },
                }}
                item
              >
                {equals(signupWithTitleEnabled, true) && showLoanIntroText && !matchesLg && <Box className={classes.imageText}>
                  Let's get started on your loan application!
                </Box>}
                <img src={svgAuthPicUrl()} alt="logo" className={classes.logo} />
                <AuthFooter>
                  <Button variant="footer" onClick={() => handleOpen({ name: TERM_OF_USE })}>
                    {TERM_OF_USE}
                  </Button>
                  <Button variant="footer" onClick={() => handleOpen({ name: PRIVACY_POLICY })}>
                    {PRIVACY_POLICY}
                  </Button>
                </AuthFooter>
              </BackgroundContainer>            </Grid>
            <Box>
              <Footer hasBorderTop />
            </Box>
          </Box>
        </Box>
      ) : (
        <>
          {renderHBSModal()}
          <IFrameModal title={title} src={externalURL} isOpen={openIframe} handleClose={handleIframeClose} />
          {children({
            handleOpen,
          })}
        </>
      )}
    </>
  );
};

export default AuthRootLayout;
